/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createXor } from '../../factoriesAny.js';
export var xorDependencies = {
  DenseMatrixDependencies,
  matrixDependencies,
  typedDependencies,
  createXor
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesXor.generated.js
// module id = 1505
// module chunks = 2